import React, { Fragment } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import AppSearch from "./AppSearch";
import AppSearchResults from "./AppSearch";
import reportWebVitals from "./reportWebVitals";

const searchPageRoot = window.bn_config_search_page.root;
const searchInputRoot = window.bn_config_search_page.root_input;
const inputInsertMode =
  window?.bn_config_search_page?.search?.frontend?.general?.inputInsertMode;
const searchPageInsertMode =
  window?.bn_config_search_page?.search?.frontend?.general
    ?.searchPageInsertMode;

const searchPageElement = document.querySelector(searchPageRoot);

let root = searchPageElement
  ? ReactDOM.createRoot(document.querySelector(searchPageRoot))
  : null;
let rootElements = [];
let searchInputRootElements = [];

let searchPageRootToRender = searchPageRoot;
let searchInputRootToRender = searchInputRoot;

if (window.bn_config_search_page && window.bn_config_search_page.mountOnStart) {
  root.render(
    <Fragment>
      <AppSearchResults onlyInput={false} />
    </Fragment>
  );
}

window.beonMountSearchPage = function (rootElement) {
  if (rootElement) {
    searchPageRootToRender = rootElement;
  }

  const elementsToShow = document.querySelectorAll(searchPageRootToRender);

  elementsToShow.forEach((el) => {
    if (searchPageInsertMode === "overwrite") {
      const searchContainer = document.createElement("div");
      searchContainer.id = "bnly-search__results-container";

      el.parentNode.insertBefore(searchContainer, el);
      el.remove();

      const root = ReactDOM.createRoot(searchContainer);

      root.render(
        <Fragment>
          <AppSearchResults onlyInput={false} />
        </Fragment>
      );

      rootElements.push(searchContainer);
    } else {
      const elm = ReactDOM.createRoot(el);
      elm.render(
        <Fragment>
          <AppSearchResults onlyInput={false} />
        </Fragment>
      );
      rootElements.push(elm);
    }
  });
};

window.beonMountSearchInput = function (rootElement) {
  if (rootElement) {
    searchInputRootToRender = rootElement;
  }

  const elementsToShow = document.querySelectorAll(searchInputRootToRender);

  elementsToShow.forEach((el) => {
    if (inputInsertMode === "overwrite") {
      const searchContainer = document.createElement("div");
      searchContainer.id = "bnly-search__input-container";

      el.parentNode.insertBefore(searchContainer, el);
      el.remove();

      const root = ReactDOM.createRoot(searchContainer);
      root.render(
        <React.StrictMode>
          <AppSearch />
        </React.StrictMode>
      );
      searchInputRootElements.push(searchContainer);
    } else {
      const elm = ReactDOM.createRoot(el);
      elm.render(
        <React.StrictMode>
          <AppSearch />
        </React.StrictMode>
      );
      searchInputRootElements.push(elm);
    }
  });
};

window.beonUnmountSearchPage = function () {
  try {
    rootElements.forEach((el) => {
      if (el) {
        el.unmount(el);
      }
    });
  } catch (e) {
    console.warn("[Beonly Search] beonUnmountSearchPage failed with", e);
  }
};

window.beonUnmountSearchInput = function () {
  try {
    searchInputRootElements.forEach((el) => {
      if (el) {
        el.unmount(el);
      }
    });
  } catch (e) {
    console.warn("[Beonly Search] beonUnmountSearchInput failed with", e);
  }
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
